window.PUBLIC_DEALER_STORES = {
    'type': 'FeatureCollection',
    'features': [
        {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -116.547894974999,
        48.2738594
      ]
    },
    "properties": {
      "name": "7B Boardshop",
      "phoneFormatted": "(208) 263-0707",
      "phone": "2082630707",
      "address": "121 N 1st Ave",
      "city": "Sandpoint",
      "country": "United States",
      "postalCode": "83864",
      "state": "ID",
      "url": "https://7bboardshop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.9392954,
        39.9082438
      ]
    },
    "properties": {
      "name": "AISTRIU Sports",
      "phoneFormatted": "(856) 267-3878",
      "phone": "8562673878",
      "address": "937 NJ-73",
      "city": "Marlton",
      "country": "United States",
      "postalCode": "08053",
      "state": "NJ",
      "url": "https://www.aistriusports.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.3825351,
        40.112573
      ]
    },
    "properties": {
      "name": "Always Boardshop",
      "phoneFormatted": "(724) 593-7800",
      "phone": "7245937800",
      "address": "3856 Route 31",
      "city": "Donegal",
      "country": "United States",
      "postalCode": "15646",
      "state": "PA",
      "url": "https://alwaysboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -149.109207572,
        60.944861988
      ]
    },
    "properties": {
      "name": "Alyeska Resort",
      "phoneFormatted": "(800) 880-3880",
      "phone": "8008803880",
      "address": "1000 Arlberg Ave",
      "city": "Girdwood",
      "country": "United States",
      "postalCode": "99587",
      "state": "AK",
      "url": "https://www.alyeskaresort.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.038375,
        37.9180574
      ]
    },
    "properties": {
      "name": "Aports Basement Walnut Creek - U105",
      "phoneFormatted": "(925) 941-6100",
      "phone": "9259416100",
      "address": "1881 Ygnacio Valley Road",
      "city": "Walnut Creek",
      "country": "United States",
      "postalCode": "94598",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -120.32870676789,
        47.4271328437883
      ]
    },
    "properties": {
      "name": "Arlberg Sports",
      "phoneFormatted": "(509) 663-7401",
      "phone": "5096637401",
      "address": "25 N Wenatchee Ave",
      "city": "Wenatchee",
      "country": "United States",
      "postalCode": "98801",
      "state": "WA",
      "url": "https://www.arlbergsports.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.0101843,
        40.1983958
      ]
    },
    "properties": {
      "name": "Aspen Ski and Board",
      "phoneFormatted": "(614) 848-6600",
      "phone": "6148486600",
      "address": "1170 E Powell Rd",
      "city": "Lewis Center",
      "country": "United States",
      "postalCode": "43035",
      "state": "OH",
      "url": "https://www.aspenskiandboard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -117.91768864286,
        33.6461964374135
      ]
    },
    "properties": {
      "name": "Attic Skate Shop",
      "phoneFormatted": "(949) 645-3457",
      "phone": "9496453457",
      "address": "2588 Newport Blvd Unit B",
      "city": "Costa Mesa",
      "country": "United States",
      "postalCode": "92627",
      "state": "CA",
      "url": "https://www.atticskateshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -116.900076945945,
        34.2446859695945
      ]
    },
    "properties": {
      "name": "Attic Skate Shop Big Bear",
      "phoneFormatted": "(909) 969-4725",
      "phone": "9099694725",
      "address": "42698 Moonridge Rd",
      "city": "Big Bear Lake",
      "country": "United States",
      "postalCode": "92315",
      "state": "CA",
      "url": "https://www.atticskateshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        150.922112,
        -33.704381
      ]
    },
    "properties": {
      "name": "Awkward Guys",
      "phoneFormatted": "",
      "phone": "",
      "address": "3 Duchess St",
      "city": "Kellyville Ridge",
      "country": "Australia",
      "postalCode": "2155",
      "state": "NSW",
      "url": "https://www.awkwardguys.com.au/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.966596,
        40.713021
      ]
    },
    "properties": {
      "name": "Backcountry.com",
      "phoneFormatted": "(801) 736-6665",
      "phone": "8017366665",
      "address": "2607 S 3200 W, Suite A",
      "city": "West Valley City",
      "country": "United States",
      "postalCode": "84119",
      "state": "UT",
      "url": "https://www.backcountry.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.004435489138,
        33.7170844946937
      ]
    },
    "properties": {
      "name": "Baker Street Snow",
      "phoneFormatted": "(714) 852-3562",
      "phone": "7148523562",
      "address": "17031 Newland St",
      "city": "Huntington Beach",
      "country": "United States",
      "postalCode": "92647",
      "state": "CA",
      "url": "https://bakerstsnow.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.5241041,
        39.6345895
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Avon",
      "phoneFormatted": "(970) 295-4899",
      "phone": "9702954899",
      "address": "75 Benchmark Rd",
      "city": "Avon",
      "country": "United States",
      "postalCode": "81620",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.5181698,
        39.6039862
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Beaver Creek Lodge",
      "phoneFormatted": "(970) 949-3141",
      "phone": "9709493141",
      "address": "26 Avondale Ln",
      "city": "Avon",
      "country": "United States",
      "postalCode": "81620",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.0464635,
        39.4844287
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Breckenridge Main Street",
      "phoneFormatted": "(970) 771-7521",
      "phone": "9707717521",
      "address": "213 N Main Street",
      "city": "Breckenridge",
      "country": "United States",
      "postalCode": "80424",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.0468539,
        39.4778402
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Breckenridge Park Avenue",
      "phoneFormatted": "(970) 453-6405",
      "phone": "9704536405",
      "address": "500 South Park Avenue",
      "city": "Breckenridge",
      "country": "United States",
      "postalCode": "80424",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.516471,
        39.605496
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Hyatt Mountain Lodge",
      "phoneFormatted": "(970) 295-4885",
      "phone": "9702954885",
      "address": "63 Avondale Ln",
      "city": "Avon",
      "country": "United States",
      "postalCode": "81620",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.516468931093,
        39.6055594464598
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Poste Montane Lodge",
      "phoneFormatted": "(970) 949-4327",
      "phone": "9709494327",
      "address": "76 Avondale Ln",
      "city": "Avon",
      "country": "United States",
      "postalCode": "81620",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -106.3876037,
        39.6433277
      ]
    },
    "properties": {
      "name": "Base Mountain Sports - Vail",
      "phoneFormatted": "(970) 476-7476",
      "phone": "9704767476",
      "address": "520 E Lionshead Cir",
      "city": "Vail",
      "country": "United States",
      "postalCode": "81657",
      "state": "CO",
      "url": "https://www.basemountainsports.com/locations/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -104.881048888461,
        39.5465274291208
      ]
    },
    "properties": {
      "name": "BC Surf & Sport",
      "phoneFormatted": "(303) 768-8908",
      "phone": "3037688908",
      "address": "8678 Park Meadows Center Dr.",
      "city": "Lonetree",
      "country": "United States",
      "postalCode": "80124",
      "state": "CO",
      "url": "https://www.bcsurf.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -123.098264,
        44.04576
      ]
    },
    "properties": {
      "name": "Berg's Ski & Snowboard Shop",
      "phoneFormatted": "(541) 683-1300",
      "phone": "5416831300",
      "address": "367 West 13th Ave",
      "city": "Eugene",
      "country": "United States",
      "postalCode": "97401",
      "state": "OR",
      "url": "https://www.bergsskishop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0720547,
        40.8086083
      ]
    },
    "properties": {
      "name": "Big Snow LLC",
      "phoneFormatted": "",
      "phone": "",
      "address": "1 American Dream Way",
      "city": "East Rutherford",
      "country": "United States",
      "postalCode": "07073",
      "state": "NJ",
      "url": "https://www.bigsnowamericandream.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -85.569484,
        42.941617
      ]
    },
    "properties": {
      "name": "Bill & Paul's Sporthaus",
      "phoneFormatted": "(616) 458-1684",
      "phone": "6164581684",
      "address": "1200 East Paris Ave #5",
      "city": "Grand Rapids",
      "country": "United States",
      "postalCode": "49546",
      "state": "MI",
      "url": "https://billandpauls.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -116.900076945945,
        34.2446859695945
      ]
    },
    "properties": {
      "name": "Blauer Board Shop",
      "phoneFormatted": "(909) 866-5689",
      "phone": "9098665689",
      "address": "41177 Big Bear Blvd",
      "city": "Big Bear Lake",
      "country": "United States",
      "postalCode": "92315",
      "state": "CA",
      "url": "https://blauerboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.5205123,
        40.8109166
      ]
    },
    "properties": {
      "name": "Blue Mountain Resort",
      "phoneFormatted": "(610) 826-7700",
      "phone": "6108267700",
      "address": "1660 Blue Mountain Drive",
      "city": "Palmerton",
      "country": "United States",
      "postalCode": "18071",
      "state": "PA",
      "url": "https://www.skibluemt.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        13.685993,
        47.397925
      ]
    },
    "properties": {
      "name": "Blue Tomato GmbH",
      "phoneFormatted": "+43 316 455 123",
      "phone": "43316455123",
      "address": "Hochstraße 628",
      "city": "Schladming",
      "country": "Austria",
      "postalCode": "8970",
      "state": "",
      "url": "https://www.blue-tomato.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -113.994299823201,
        46.8546243432853
      ]
    },
    "properties": {
      "name": "Board of Missoula",
      "phoneFormatted": "(406) 721-7774",
      "phone": "4067217774",
      "address": "618 S Higgins Ave",
      "city": "Missoula",
      "country": "United States",
      "postalCode": "59801",
      "state": "MT",
      "url": "https://boardofmissoula.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.6587085,
        40.2337289
      ]
    },
    "properties": {
      "name": "Board of Provo",
      "phoneFormatted": "(801) 356-3185",
      "phone": "8013563185",
      "address": "465 N. University Ave",
      "city": "Provo",
      "country": "United States",
      "postalCode": "84041",
      "state": "UT",
      "url": "https://boardofprovo.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.769782,
        36.0874059
      ]
    },
    "properties": {
      "name": "Boardparadise",
      "phoneFormatted": "(336) 545-6115",
      "phone": "3365456115",
      "address": "1206 E Wendover Ave",
      "city": "Greensboro",
      "country": "United States",
      "postalCode": "27405",
      "state": "NC",
      "url": "https://www.boardparadise.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -84.95533,
        45.373343
      ]
    },
    "properties": {
      "name": "Boyne Country Sports",
      "phoneFormatted": "(231) 439-4906",
      "phone": "2314394906",
      "address": "1200 Bay View Rd",
      "city": "Petoskey",
      "country": "United States",
      "postalCode": "49770",
      "state": "MI",
      "url": "https://boynecountrysports.com/pages/stores"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0403215514097,
        40.3272043140548
      ]
    },
    "properties": {
      "name": "Brave New World - Little Silver",
      "phoneFormatted": "(732) 842-6767",
      "phone": "7328426767",
      "address": "61 Oceanport Ave",
      "city": "Little Silver",
      "country": "United States",
      "postalCode": "07739",
      "state": "NJ",
      "url": "https://www.bravesurf.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0481155856015,
        40.1217324971076
      ]
    },
    "properties": {
      "name": "Brave New World - Manasquan",
      "phoneFormatted": "(908) 783-8366",
      "phone": "9087838366",
      "address": "146 Main St",
      "city": "Manasquan",
      "country": "United States",
      "postalCode": "08736",
      "state": "NJ",
      "url": "https://www.bravesurf.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0487557959183,
        40.0852307755102
      ]
    },
    "properties": {
      "name": "Brave New World - Point Pleasant Beach",
      "phoneFormatted": "(732) 899-8220",
      "phone": "7328998220",
      "address": "1208 Richmond Ave",
      "city": "Point Pleasant Beach",
      "country": "United States",
      "postalCode": "08742",
      "state": "NJ",
      "url": "https://www.bravesurf.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.1797863398818,
        39.9846585310036
      ]
    },
    "properties": {
      "name": "Brave New World - Toms River",
      "phoneFormatted": "(732) 505-3600",
      "phone": "7325053600",
      "address": "1272 Hooper Ave",
      "city": "Toms River",
      "country": "United States",
      "postalCode": "08753",
      "state": "NJ",
      "url": "https://www.bravesurf.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.2910925,
        40.007939
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Ardmore",
      "phoneFormatted": "(610) 658-0470",
      "phone": "6106580470",
      "address": "26 W. Lancaster Avenue",
      "city": "Ardmore",
      "country": "United States",
      "postalCode": "19003",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.127557454677,
        40.3138862706459
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Doylestown",
      "phoneFormatted": "(215) 348-5624",
      "phone": "2153485624",
      "address": "635 North Main Street",
      "city": "Doylestown",
      "country": "United States",
      "postalCode": "18901",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.6467302477648,
        40.0451020630223
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Exton",
      "phoneFormatted": "(610) 363-1893",
      "phone": "6103631893",
      "address": "403 Pottstown Pike",
      "city": "Exton",
      "country": "United States",
      "postalCode": "19341",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.3888122,
        40.0851221
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop King of Prussia",
      "phoneFormatted": "(610) 265-3330",
      "phone": "6102653330",
      "address": "740 DeKalb Pike",
      "city": "King of Prussia",
      "country": "United States",
      "postalCode": "19406",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.2437854,
        40.2473291
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Montgomeryville",
      "phoneFormatted": "(215) 368-4418",
      "phone": "2153684418",
      "address": "925 Bethlehem Pike (Route 309)",
      "city": "Montgomeryville",
      "country": "United States",
      "postalCode": "18936",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.9279495,
        40.335345
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Reading",
      "phoneFormatted": "(610) 678-5960",
      "phone": "6106785960",
      "address": "301 E. Bellevue Ave.",
      "city": "Reading",
      "country": "United States",
      "postalCode": "19605",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.4955545207118,
        40.6497602418158
      ]
    },
    "properties": {
      "name": "Buckman's Ski & Snowboard Shop Whitehall",
      "phoneFormatted": "(610) 435-1242",
      "phone": "6104351242",
      "address": "2510 MacArthur Road",
      "city": "Whitehall",
      "country": "United States",
      "postalCode": "18052",
      "state": "PA",
      "url": "https://buckmans.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.0821545,
        40.7361036
      ]
    },
    "properties": {
      "name": "Bunger",
      "phoneFormatted": "(631) 244-7070",
      "phone": "6312447070",
      "address": "247A W Main St",
      "city": "Sayville",
      "country": "United States",
      "postalCode": "11782",
      "state": "NY",
      "url": "https://www.bungersayville.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.456802,
        40.275249
      ]
    },
    "properties": {
      "name": "Cabin Craft Ski Shop",
      "phoneFormatted": "(610) 287-7064",
      "phone": "6102877064",
      "address": "2 Main St",
      "city": "Spring Mount",
      "country": "United States",
      "postalCode": "19478",
      "state": "PA",
      "url": "https://www.cabincraftoutdoor.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -93.2883981723806,
        44.9457246229198
      ]
    },
    "properties": {
      "name": "Cal Surf",
      "phoneFormatted": "(612) 822-6840",
      "phone": "6128226840",
      "address": "1715 W Lake St",
      "city": "Minneapolis",
      "country": "United States",
      "postalCode": "55408",
      "state": "MN",
      "url": "https://www.cal-surf.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -89.6272791,
        44.9597858
      ]
    },
    "properties": {
      "name": "Central Board Shop",
      "phoneFormatted": "(715) 848-0400",
      "phone": "7158480400",
      "address": "426 N 3rd Street",
      "city": "Wausau",
      "country": "United States",
      "postalCode": "54403",
      "state": "WI",
      "url": "https://www.central-boardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -105.120698290444,
        39.731323
      ]
    },
    "properties": {
      "name": "Christy Sports",
      "phoneFormatted": "(888) 413-6966",
      "phone": "8884136966",
      "address": "875 Parfet St",
      "city": "Lakewood",
      "country": "United States",
      "postalCode": "80215",
      "state": "CO",
      "url": "https://www.christysports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.4884081637991,
        41.6443143395348
      ]
    },
    "properties": {
      "name": "Civil Skateboard Shop - East Greenwich",
      "phoneFormatted": "(401) 886-5116",
      "phone": "4018865116",
      "address": "86 Main Street",
      "city": "East Greenwich",
      "country": "United States",
      "postalCode": "02818",
      "state": "RI",
      "url": "https://wearecivil.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.4092735772321,
        41.8212421598214
      ]
    },
    "properties": {
      "name": "Civil Skateboard Shop - Providence",
      "phoneFormatted": "(401) 383-1622",
      "phone": "4013831622",
      "address": "231 Westminster St",
      "city": "Providence",
      "country": "United States",
      "postalCode": "02903",
      "state": "RI",
      "url": "https://wearecivil.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.8230528028301,
        41.3509002245283
      ]
    },
    "properties": {
      "name": "Civil Skateboard Shop - Westerly",
      "phoneFormatted": "(401) 596-0028",
      "phone": "4015960028",
      "address": "130 Granite Street",
      "city": "Westerly",
      "country": "United States",
      "postalCode": "02891",
      "state": "RI",
      "url": "https://wearecivil.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        19.8375908,
        50.1060554
      ]
    },
    "properties": {
      "name": "COOL SPORT SP.Z O.O. SP. K",
      "phoneFormatted": "",
      "phone": "",
      "address": "ul. Handlowców 2",
      "city": "Modlniczka",
      "country": "Poland",
      "postalCode": "32-085",
      "state": "Małopolskie",
      "url": ""
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.7456519,
        41.621488
      ]
    },
    "properties": {
      "name": "Cutting Edge",
      "phoneFormatted": "(860) 828-3428",
      "phone": "8608283428",
      "address": "146 Mill St",
      "city": "Berlin",
      "country": "United States",
      "postalCode": "06037",
      "state": "CT",
      "url": "https://www.cuttingedgect.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.039419,
        39.922169
      ]
    },
    "properties": {
      "name": "D&Q Skate, Snow, Surf",
      "phoneFormatted": "(856) 520-8570",
      "phone": "8565208570",
      "address": "1409 NJ-70, Unit 200",
      "city": "Cherry Hill",
      "country": "United States",
      "postalCode": "08034",
      "state": "NJ",
      "url": "https://dandq.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -92.1351612518882,
        46.7658109637351
      ]
    },
    "properties": {
      "name": "Damage Boardshop",
      "phoneFormatted": "(218) 724-4027",
      "phone": "2187244027",
      "address": "1904 W Superior St",
      "city": "Duluth",
      "country": "United States",
      "postalCode": "55806",
      "state": "MN",
      "url": "http://www.damageboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.7784445,
        43.67433
      ]
    },
    "properties": {
      "name": "Darkside Snowboards",
      "phoneFormatted": "(802) 422-8600",
      "phone": "8024228600",
      "address": "1842 Killington Rd",
      "city": "Killington",
      "country": "United States",
      "postalCode": "05751",
      "state": "VT",
      "url": "https://www.darksidesnowboards.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.828680962317,
        41.737295234059
      ]
    },
    "properties": {
      "name": "Directive Boardshop",
      "phoneFormatted": "(435) 752-0155",
      "phone": "4357520155",
      "address": "65 S Main St",
      "city": "Logan",
      "country": "United States",
      "postalCode": "84321",
      "state": "UT",
      "url": "https://www.directiveboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.8018877,
        42.2625621
      ]
    },
    "properties": {
      "name": "Eastern Boarder",
      "phoneFormatted": "(508) 852-3668",
      "phone": "5088523668",
      "address": "7 Jackson St",
      "city": "Worcester",
      "country": "United States",
      "postalCode": "01608",
      "state": "MA",
      "url": "https://easternboarder.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        12.0875483,
        47.8496606
      ]
    },
    "properties": {
      "name": "Element Sports GmbH & Co. KG",
      "phoneFormatted": "+49 8031 9413690",
      "phone": "4980319413690",
      "address": "Kolbermoorer Str. 16",
      "city": "Rosenheim",
      "country": "Germany",
      "postalCode": "83026",
      "state": "Bavaria",
      "url": "https://www.es-db.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -104.996730963,
        39.750985333
      ]
    },
    "properties": {
      "name": "Emage",
      "phoneFormatted": "(720) 855-8297",
      "phone": "7208558297",
      "address": "1620 Platte St",
      "city": "Denver",
      "country": "United States",
      "postalCode": "80202",
      "state": "CO",
      "url": "https://www.emagenetwork.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -93.1931988,
        44.9181583
      ]
    },
    "properties": {
      "name": "Eriks Bike and Board",
      "phoneFormatted": "(651) 699-4679",
      "phone": "6516994679",
      "address": "2191 Ford Pkwy",
      "city": "Saint Paul",
      "country": "United States",
      "postalCode": "55116",
      "state": "MN",
      "url": "https://www.eriksbikeshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.897838184,
        40.755424441
      ]
    },
    "properties": {
      "name": "evo Salt Lake City Flagship Store",
      "phoneFormatted": "(385) 379-3172",
      "phone": "3853793172",
      "address": "660 S 400 W, Suite 300",
      "city": "Salt Lake City",
      "country": "United States",
      "postalCode": "84101",
      "state": "UT",
      "url": "https://www.evo.com/locations/salt-lake-city"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.344015221,
        47.673544448
      ]
    },
    "properties": {
      "name": "evo Seattle Flagship Store",
      "phoneFormatted": "(206) 973-4470",
      "phone": "2069734470",
      "address": "3500 Stone Way N",
      "city": "Seattle",
      "country": "United States",
      "postalCode": "98103",
      "state": "WA",
      "url": "https://www.evo.com/locations/seattle"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.5135746,
        42.6495775
      ]
    },
    "properties": {
      "name": "Exodus",
      "phoneFormatted": "(248) 520-9774",
      "phone": "2485209774",
      "address": "7401 Highland Rd",
      "city": "White Lake",
      "country": "United States",
      "postalCode": "48383",
      "state": "MI",
      "url": "https://exodusrideshop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -94.1596549,
        45.558753
      ]
    },
    "properties": {
      "name": "Fitsharris Ski Bike and Outdoor",
      "phoneFormatted": "(320) 251-2844",
      "phone": "3202512844",
      "address": "105 7th Ave S",
      "city": "St. Cloud",
      "country": "United States",
      "postalCode": "56301",
      "state": "MN",
      "url": "https://www.fitzharrismn.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -89.3489422234375,
        43.119860428125
      ]
    },
    "properties": {
      "name": "Focus Boardshop",
      "phoneFormatted": "(608) 242-8403",
      "phone": "6082428403",
      "address": "2358 E Springs Dr",
      "city": "Madison",
      "country": "United States",
      "postalCode": "53704",
      "state": "WI",
      "url": "https://www.focusmadison.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.859272,
        40.494623
      ]
    },
    "properties": {
      "name": "Fox Chapel",
      "phoneFormatted": "(412) 828-4754",
      "phone": "4128284754",
      "address": "392 Freeport Road",
      "city": "Blawnox",
      "country": "United States",
      "postalCode": "15238",
      "state": "PA",
      "url": "https://www.foxchapelskiandboard.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -117.6852633,
        33.4652486
      ]
    },
    "properties": {
      "name": "Garage Skateshop - Dana Point",
      "phoneFormatted": "(949) 276-8080",
      "phone": "9492768080",
      "address": "34320 Pacific Coast Hwy",
      "city": "Dana Point",
      "country": "United States",
      "postalCode": "92629",
      "state": "CA",
      "url": "https://garageskateshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.001743996767,
        33.6575447771731
      ]
    },
    "properties": {
      "name": "Garage Skateshop - Huntington Beach",
      "phoneFormatted": "(714) 536-4516",
      "phone": "7145364516",
      "address": "101 Main St",
      "city": "Huntington Beach",
      "country": "United States",
      "postalCode": "92648",
      "state": "CA",
      "url": "https://garageskateshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -93.5715908,
        44.9863892
      ]
    },
    "properties": {
      "name": "Gear West",
      "phoneFormatted": "(952) 473-0377",
      "phone": "9524730377",
      "address": "1786 Wayzata Blvd",
      "city": "Long Lake",
      "country": "United States",
      "postalCode": "55356",
      "state": "MN",
      "url": "https://www.gearwest.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.525414,
        43.626676
      ]
    },
    "properties": {
      "name": "Grand Trading",
      "phoneFormatted": "",
      "phone": "",
      "address": "29 Jutland Rd",
      "city": "Etobicoke",
      "country": "Canada",
      "postalCode": "M8Z 2G6",
      "state": "ON",
      "url": "https://www.grandtrading.ca/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -85.74336175,
        42.8814289204545
      ]
    },
    "properties": {
      "name": "Great Lakes Outpost",
      "phoneFormatted": "(616) 777-5681",
      "phone": "6167775681",
      "address": "4611 Ivanrest Ave SW",
      "city": "Grandville",
      "country": "United States",
      "postalCode": "49418",
      "state": "MI",
      "url": "https://www.greatlakesoutpost.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.3333955274544,
        39.5226353450508
      ]
    },
    "properties": {
      "name": "High Mountain Sports",
      "phoneFormatted": "(301) 387-4199",
      "phone": "3013874199",
      "address": "21327 Garrett Highway",
      "city": "Oakland",
      "country": "United States",
      "postalCode": "21550",
      "state": "MD",
      "url": "https://www.highmountainsports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.1812913,
        40.9995386
      ]
    },
    "properties": {
      "name": "Holy Stokes",
      "phoneFormatted": "(570) 213-8357",
      "phone": "5702138357",
      "address": "114 Washington St Suite 200",
      "city": "East Stroudsburg",
      "country": "United States",
      "postalCode": "18301",
      "state": "PA",
      "url": "https://holystokes.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -93.1038421999999,
        45.0063703333333
      ]
    },
    "properties": {
      "name": "Joe's Sporting Goods",
      "phoneFormatted": "(651) 209-7800",
      "phone": "6512097800",
      "address": "33 East County Rd B",
      "city": "St. Paul",
      "country": "United States",
      "postalCode": "55117",
      "state": "MN",
      "url": "https://joessportinggoods.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.415207,
        44.609997
      ]
    },
    "properties": {
      "name": "Kahuna Shop",
      "phoneFormatted": "(705) 325-2461",
      "phone": "7053252461",
      "address": "175 Mississaga St E",
      "city": "Orillia",
      "country": "Canada",
      "postalCode": "L3V 1V8",
      "state": "ON",
      "url": "https://www.kahunasurfshop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.546589,
        39.7459468
      ]
    },
    "properties": {
      "name": "Kinetic Skateboarding",
      "phoneFormatted": "(302) 477-1533",
      "phone": "3024771533",
      "address": "3906 Concord Pike",
      "city": "Wilmington",
      "country": "United States",
      "postalCode": "19803",
      "state": "DE",
      "url": "https://kineticskateboarding.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -88.1497867147918,
        43.0593193397087
      ]
    },
    "properties": {
      "name": "Les Moise - Brookfield",
      "phoneFormatted": "(262) 879-0800",
      "phone": "2628790800",
      "address": "19730 W. Bluemound Rd.",
      "city": "Brookfield",
      "country": "United States",
      "postalCode": "53045",
      "state": "WI",
      "url": "http://www.lesmoiseinc.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.9387109832346,
        43.2123171344187
      ]
    },
    "properties": {
      "name": "Les Moise - Mequon",
      "phoneFormatted": "(262) 518-0069",
      "phone": "2625180069",
      "address": "10130 N. Port Washington Rd",
      "city": "Mequon",
      "country": "United States",
      "postalCode": "53092",
      "state": "WI",
      "url": "http://www.lesmoiseinc.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.814292226794,
        40.7045352097212
      ]
    },
    "properties": {
      "name": "Level Nine Sports Millcreek",
      "phoneFormatted": "(801) 466-9880",
      "phone": "8014669880",
      "address": "2927 E 3300 S",
      "city": "Millcreek",
      "country": "United States",
      "postalCode": "84109",
      "state": "UT",
      "url": "http://www.levelninesports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.962268341604,
        41.2670590179295
      ]
    },
    "properties": {
      "name": "Level Nine Sports Ogden",
      "phoneFormatted": "(801) 621-2003",
      "phone": "8016212003",
      "address": "1273 Canyon Rd",
      "city": "Ogden",
      "country": "United States",
      "postalCode": "84404",
      "state": "UT",
      "url": "http://www.levelninesports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.706119143817,
        40.3170719708099
      ]
    },
    "properties": {
      "name": "Level Nine Sports Orem",
      "phoneFormatted": "(801) 607-2493",
      "phone": "8016072493",
      "address": "644 N State St",
      "city": "Orem",
      "country": "United States",
      "postalCode": "84057",
      "state": "UT",
      "url": "http://www.levelninesports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.897838184,
        40.755424441
      ]
    },
    "properties": {
      "name": "Level Nine Sports Salt Lake City",
      "phoneFormatted": "(801) 973-7350",
      "phone": "8019737350",
      "address": "660 S 400 W",
      "city": "Salt Lake City",
      "country": "United States",
      "postalCode": "84101",
      "state": "UT",
      "url": "http://www.levelninesports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.3715275826693,
        41.6562618485046
      ]
    },
    "properties": {
      "name": "Little Mtn Ltd",
      "phoneFormatted": "",
      "phone": "",
      "address": "7560 Mentor Ave",
      "city": "Mentor",
      "country": "United States",
      "postalCode": "44060",
      "state": "OH",
      "url": ""
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        139.3811613,
        35.3990924
      ]
    },
    "properties": {
      "name": "Maneuverline - Kanagawa",
      "phoneFormatted": "+81 467-72-6226",
      "phone": "81467726226",
      "address": "6-8-24 Ichinomiya, Samukawa-machi, Koza-gun",
      "city": "Samukawa",
      "country": "Japan",
      "postalCode": "253-0111",
      "state": "Kanagawa",
      "url": "https://www.maneuverline.co.jp/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        135.5235559,
        34.60223065
      ]
    },
    "properties": {
      "name": "Maneuverline - Osaka headquarters",
      "phoneFormatted": "+81 6-6609-0035",
      "phone": "81666090035",
      "address": "1-17-8 Koenminamiyata, Higashisumiyoshi-ku",
      "city": "Osaka",
      "country": "Japan",
      "postalCode": "546-0024",
      "state": "Osaka",
      "url": "https://www.maneuverline.co.jp/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        139.8154194,
        35.6579776
      ]
    },
    "properties": {
      "name": "Maneuverline - Tokyo",
      "phoneFormatted": "+81 3-5245-3113",
      "phone": "81352453113",
      "address": "3-8-2 Miyoshi, Koto-ku",
      "city": "Tokyo",
      "country": "Japan",
      "postalCode": "135-0022",
      "state": "Tokyo",
      "url": "https://www.maneuverline.co.jp/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        7.265017,
        47.1194582
      ]
    },
    "properties": {
      "name": "MB Sportswear GMBH - Brügg office",
      "phoneFormatted": "+41 32 313 13 33",
      "phone": "41323131333",
      "address": "Erlenstrasse 44a",
      "city": "Brügg",
      "country": "Switzerland",
      "postalCode": "2555",
      "state": "Bern",
      "url": "https://www.mbsportswear.ch/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        8.5576082,
        47.4229201
      ]
    },
    "properties": {
      "name": "MB Sportswear GMBH - Opfikon showroom",
      "phoneFormatted": "+41 32 313 13 33",
      "phone": "41323131333",
      "address": "Thurgauerstrasse 109",
      "city": "Opfikon",
      "country": "Switzerland",
      "postalCode": "8152",
      "state": "Zürich",
      "url": "https://www.mbsportswear.ch/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.075627789156,
        38.9198357807228
      ]
    },
    "properties": {
      "name": "Milo Snow and Skate",
      "phoneFormatted": "(530) 878-5889",
      "phone": "5308785889",
      "address": "905 Lincoln Way",
      "city": "Auburn",
      "country": "United States",
      "postalCode": "95603",
      "state": "CA",
      "url": "https://www.milosnowandskate.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.886797,
        40.7596198
      ]
    },
    "properties": {
      "name": "Milosport",
      "phoneFormatted": "(801) 487-8600",
      "phone": "8014878600",
      "address": "3119 E 3300 S",
      "city": "Salt Lake City",
      "country": "United States",
      "postalCode": "84109",
      "state": "UT",
      "url": "https://www.milosport.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.6691223,
        41.6719835
      ]
    },
    "properties": {
      "name": "MOUNTAIN MAN WEST LLC",
      "phoneFormatted": "",
      "phone": "",
      "address": "2735 N Reynolds Rd",
      "city": "Toledo",
      "country": "United States",
      "postalCode": "43615",
      "state": "OH",
      "url": "https://www.mountainmansports.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.664763,
        45.332046
      ]
    },
    "properties": {
      "name": "Mt Hood Meadows",
      "phoneFormatted": "(503) 337-2222",
      "phone": "5033372222",
      "address": "14040 Highway 35",
      "city": "Mount Hood",
      "country": "United States",
      "postalCode": "97041",
      "state": "OR",
      "url": "https://www.skihood.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -78.6727799,
        42.2751873
      ]
    },
    "properties": {
      "name": "Mud Sweat n' Gears",
      "phoneFormatted": "(716) 699-8300",
      "phone": "7166998300",
      "address": "18 Monroe St",
      "city": "Ellicottville",
      "country": "United States",
      "postalCode": "14731",
      "state": "NY",
      "url": "https://mudsweatgears.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -77.4369681,
        43.02687
      ]
    },
    "properties": {
      "name": "Neon Wave",
      "phoneFormatted": "",
      "phone": "",
      "address": "237 High Street Extension",
      "city": "Victor",
      "country": "United States",
      "postalCode": "14564",
      "state": "NY",
      "url": "https://thisisneonwave.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.213234,
        42.4761409
      ]
    },
    "properties": {
      "name": "NOTB Ski Haus - Burlington",
      "phoneFormatted": "",
      "phone": "",
      "address": "1 Wheeler Rd",
      "city": "Burlington",
      "country": "United States",
      "postalCode": "01803",
      "state": "MA",
      "url": "https://skihaus.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.210369,
        42.756462
      ]
    },
    "properties": {
      "name": "NOTB Ski Haus - Salem",
      "phoneFormatted": "(603) 898-1722",
      "phone": "6038981722",
      "address": "317 S Broadway",
      "city": "Salem",
      "country": "United States",
      "postalCode": "03079",
      "state": "NH",
      "url": "https://skihaus.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.2971009,
        41.3796673
      ]
    },
    "properties": {
      "name": "OC Snowboards",
      "phoneFormatted": "",
      "phone": "",
      "address": "1778 Route 17M",
      "city": "Goshen",
      "country": "United States",
      "postalCode": "10924",
      "state": "NY",
      "url": "https://www.ocsnowboards.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.361189,
        40.053173
      ]
    },
    "properties": {
      "name": "Outfitters Ski Shop",
      "phoneFormatted": "(717) 397-5432",
      "phone": "7173975432",
      "address": "2221 Marietta Ave",
      "city": "Lancaster",
      "country": "United States",
      "postalCode": "17603",
      "state": "PA",
      "url": "https://www.outfittersskishop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.4937437790566,
        41.1877090032075
      ]
    },
    "properties": {
      "name": "Outkast Sports",
      "phoneFormatted": "(862) 266-3582",
      "phone": "8622663582",
      "address": "216 NJ-94",
      "city": "Vernon Township",
      "country": "United States",
      "postalCode": "07462",
      "state": "NJ",
      "url": "https://www.rideoutkast.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -90.4433296553351,
        38.6139254828595
      ]
    },
    "properties": {
      "name": "Outpost Board shop",
      "phoneFormatted": "(314) 965-1444",
      "phone": "3149651444",
      "address": "12011 Manchester Rd",
      "city": "St Louis",
      "country": "United States",
      "postalCode": "63131",
      "state": "MO",
      "url": "https://outpostboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.7501794912504,
        41.0096197050674
      ]
    },
    "properties": {
      "name": "Pedigree Ski Shop",
      "phoneFormatted": "(914) 948-2995",
      "phone": "9149482995",
      "address": "355 Mamaroneck Ave",
      "city": "White Plains",
      "country": "United States",
      "postalCode": "10605",
      "state": "NY",
      "url": "https://www.pedigreeskishop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.7001868,
        41.2366622
      ]
    },
    "properties": {
      "name": "Pedigree Ski Shop",
      "phoneFormatted": "(914) 244-8960",
      "phone": "9142448960",
      "address": "532 Bedford Rd.",
      "city": "Bedford Hills",
      "country": "United States",
      "postalCode": "10507",
      "state": "NY",
      "url": "https://www.pedigreeskishop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.4811234,
        40.8221007
      ]
    },
    "properties": {
      "name": "Pelican Snowboard Shop",
      "phoneFormatted": "(973) 267-0964",
      "phone": "9732670964",
      "address": "2980 Route 10",
      "city": "Morris Plains",
      "country": "United States",
      "postalCode": "07950",
      "state": "NJ",
      "url": "https://pelicanshops.com/locations/morris-plains/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.3438248,
        42.6080884
      ]
    },
    "properties": {
      "name": "People Skate and Snowboard",
      "phoneFormatted": "(248) 499-7472",
      "phone": "2484997472",
      "address": "3375 Orchard Lake Rd",
      "city": "Keego Harbor",
      "country": "United States",
      "postalCode": "48320",
      "state": "MI",
      "url": "https://peopleskateandsnowboard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -84.8499504,
        39.090891
      ]
    },
    "properties": {
      "name": "Perfect North Slopes",
      "phoneFormatted": "(812) 537-3754",
      "phone": "8125373754",
      "address": "19074 Perfect Lane",
      "city": "Lawrenceburg",
      "country": "United States",
      "postalCode": "47025",
      "state": "IN",
      "url": "https://perfectnorth.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.0875143,
        26.4384922
      ]
    },
    "properties": {
      "name": "Peter Glenn - Delray Beach",
      "phoneFormatted": "(561) 330-8501",
      "phone": "5613308501",
      "address": "1350 Linton Blvd",
      "city": "Delray Beach",
      "country": "United States",
      "postalCode": "33444",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.183209,
        26.165509
      ]
    },
    "properties": {
      "name": "Peter Glenn - Fort Lauderdale",
      "phoneFormatted": "(954) 484-3606",
      "phone": "9544843606",
      "address": "2901 W Oakland Park Blvd",
      "city": "Fort Lauderdale",
      "country": "United States",
      "postalCode": "33311",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.2188322,
        25.9280924
      ]
    },
    "properties": {
      "name": "Peter Glenn - North Miami",
      "phoneFormatted": "(305) 622-6440",
      "phone": "3056226440",
      "address": "900 Park Centre Blvd #444",
      "city": "Miami",
      "country": "United States",
      "postalCode": "33169",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.4526321,
        28.4628191
      ]
    },
    "properties": {
      "name": "Peter Glenn - Orlando",
      "phoneFormatted": "(407) 354-1234",
      "phone": "4073541234",
      "address": "5403 International Drive",
      "city": "Orlando",
      "country": "United States",
      "postalCode": "32819",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -84.379005,
        33.926398
      ]
    },
    "properties": {
      "name": "Peter Glenn - Sandy Springs",
      "phoneFormatted": "(404) 257-1706",
      "phone": "4042571706",
      "address": "6285 Roswell Road",
      "city": "Sandy Springs",
      "country": "United States",
      "postalCode": "30328",
      "state": "GA",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.3260655838926,
        25.6609368322147
      ]
    },
    "properties": {
      "name": "Peter Glenn - South Miami",
      "phoneFormatted": "(305) 254-3309",
      "phone": "3052543309",
      "address": "11855 S Dixie Hwy",
      "city": "Miami",
      "country": "United States",
      "postalCode": "33156",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -82.5043881,
        28.0157159
      ]
    },
    "properties": {
      "name": "Peter Glenn - Tampa",
      "phoneFormatted": "(813) 960-2453",
      "phone": "8139602453",
      "address": "7229 N Dale Mabry Highway",
      "city": "Tampa",
      "country": "United States",
      "postalCode": "33614",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.0917388,
        26.7077663
      ]
    },
    "properties": {
      "name": "Peter Glenn - West Palm Beach",
      "phoneFormatted": "(561) 622-7940",
      "phone": "5616227940",
      "address": "2505 Okeechobee Blvd",
      "city": "West Palm Beach",
      "country": "United States",
      "postalCode": "33409",
      "state": "FL",
      "url": "https://peterglenn.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -78.8140627,
        42.9758258
      ]
    },
    "properties": {
      "name": "Phatman",
      "phoneFormatted": "(716) 837-8743",
      "phone": "7168378743",
      "address": "4430 Bailey Ave",
      "city": "Buffalo",
      "country": "United States",
      "postalCode": "14226",
      "state": "NY",
      "url": "https://phatmanboardshop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.7958775,
        42.7618963
      ]
    },
    "properties": {
      "name": "Play It again Sports Latham",
      "phoneFormatted": "(518) 785-6587",
      "phone": "5187856587",
      "address": "952 Troy-Schenectady Rd",
      "city": "Latham",
      "country": "United States",
      "postalCode": "12110",
      "state": "NY",
      "url": "https://playitagainsports.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0130338365868,
        41.9343075147569
      ]
    },
    "properties": {
      "name": "Potter Brothers Ski and Snowboard Shop",
      "phoneFormatted": "(845) 338-5119",
      "phone": "8453385119",
      "address": "57 City View Terrace",
      "city": "Kingston",
      "country": "United States",
      "postalCode": "12401",
      "state": "NY",
      "url": "https://potterbrothers.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.520945130497,
        38.9836516317018
      ]
    },
    "properties": {
      "name": "Pure Boardshop",
      "phoneFormatted": "(410) 267-7669",
      "phone": "4102677669",
      "address": "1908 Forest Dr",
      "city": "Annapolis",
      "country": "United States",
      "postalCode": "21401",
      "state": "MD",
      "url": "https://www.pureboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.6654535410217,
        36.2106337066115
      ]
    },
    "properties": {
      "name": "Recess Skate & Snow",
      "phoneFormatted": "(828) 355-9013",
      "phone": "8283559013",
      "address": "1158 NC-105",
      "city": "Boone",
      "country": "United States",
      "postalCode": "28607",
      "state": "NC",
      "url": "https://recessrideshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.6552522,
        43.297675
      ]
    },
    "properties": {
      "name": "Rope Drop Projects, LLC",
      "phoneFormatted": "",
      "phone": "",
      "address": "17 Woodard Street",
      "city": "Glens Falls",
      "country": "United States",
      "postalCode": "12804",
      "state": "NY",
      "url": ""
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -97.7436995,
        30.2711286
      ]
    },
    "properties": {
      "name": "Saint Bernard - Austin",
      "phoneFormatted": "(737) 304-7003",
      "phone": "7373047003",
      "address": "3201 Bee Caves Road",
      "city": "Austin",
      "country": "United States",
      "postalCode": "78746",
      "state": "TX",
      "url": "https://www.saintbernard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -96.829211704,
        32.839929635
      ]
    },
    "properties": {
      "name": "Saint Bernard - Dallas",
      "phoneFormatted": "(214) 357-9700",
      "phone": "2143579700",
      "address": "5570 W. Lovers Ln #388",
      "city": "Dallas",
      "country": "United States",
      "postalCode": "75209",
      "state": "TX",
      "url": "https://www.saintbernard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -95.448820147,
        29.741412284
      ]
    },
    "properties": {
      "name": "Saint Bernard - Houston",
      "phoneFormatted": "(713) 388-6888",
      "phone": "7133886888",
      "address": "4444 Westheimer RD G100",
      "city": "Houston",
      "country": "United States",
      "postalCode": "77027",
      "state": "TX",
      "url": "https://www.saintbernard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -98.458577974,
        29.486133111
      ]
    },
    "properties": {
      "name": "Saint Bernard - San Antonio",
      "phoneFormatted": "(726) 208-0477",
      "phone": "7262080477",
      "address": "999 E. Basse RD Suite 157",
      "city": "San Antonio",
      "country": "United States",
      "postalCode": "78209",
      "state": "TX",
      "url": "https://www.saintbernard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -97.1460236061565,
        32.9427141194371
      ]
    },
    "properties": {
      "name": "Saint Bernard - Southlake",
      "phoneFormatted": "(817) 329-0322",
      "phone": "8173290322",
      "address": "1275 E. Southlake BLVD Suite #401",
      "city": "Southlake",
      "country": "United States",
      "postalCode": "76092",
      "state": "TX",
      "url": "https://www.saintbernard.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -105.217283146641,
        40.0476636491915
      ]
    },
    "properties": {
      "name": "Satellite Boardshop",
      "phoneFormatted": "(303) 374-3275",
      "phone": "3033743275",
      "address": "3044 Valmont Rd",
      "city": "Boulder",
      "country": "United States",
      "postalCode": "80301",
      "state": "CO",
      "url": "https://www.satelliteboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.6869658857142,
        43.0116565544303
      ]
    },
    "properties": {
      "name": "Shumaker's Ski Shop",
      "phoneFormatted": "(810) 239-6931",
      "phone": "8102396931",
      "address": "2342 S Ballenger Hwy",
      "city": "Flint",
      "country": "United States",
      "postalCode": "48503",
      "state": "MI",
      "url": "https://www.facebook.com/people/Shumakers-Ski-Snowboard/100064083965994/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.9145535211428,
        42.5940066766666
      ]
    },
    "properties": {
      "name": "Skaters Advocate",
      "phoneFormatted": "(517) 545-9366",
      "phone": "5175459366",
      "address": "106 N State St",
      "city": "Howell",
      "country": "United States",
      "postalCode": "48843",
      "state": "MI",
      "url": "https://www.skatersadvocate.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.6808933,
        40.2971555
      ]
    },
    "properties": {
      "name": "Ski Barn - Lawrenceville",
      "phoneFormatted": "(609) 530-1666",
      "phone": "6095301666",
      "address": "2990 Brunswick Pike, Route 1 North",
      "city": "Lawrenceville",
      "country": "United States",
      "postalCode": "08648",
      "state": "NJ",
      "url": "https://skibarn.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0682613856975,
        40.9449815921453
      ]
    },
    "properties": {
      "name": "Ski Barn - Parasmus",
      "phoneFormatted": "(201) 445-9070",
      "phone": "2014459070",
      "address": "846 Route 17 North",
      "city": "Paramus",
      "country": "United States",
      "postalCode": "07652",
      "state": "NJ",
      "url": "https://skibarn.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.0589915970588,
        40.3256990568627
      ]
    },
    "properties": {
      "name": "Ski Barn - Shrewsbury",
      "phoneFormatted": "(732) 945-3900",
      "phone": "7329453900",
      "address": "795 Broad Street",
      "city": "Shrewsbury",
      "country": "United States",
      "postalCode": "07702",
      "state": "NJ",
      "url": "https://skibarn.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.2481108511521,
        40.9455920073035
      ]
    },
    "properties": {
      "name": "Ski Barn - Wayne",
      "phoneFormatted": "(973) 256-8585",
      "phone": "9732568585",
      "address": "1308 Route 23 North",
      "city": "Wayne",
      "country": "United States",
      "postalCode": "07470",
      "state": "NJ",
      "url": "https://skibarn.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.7492209268493,
        41.1914028216438
      ]
    },
    "properties": {
      "name": "Ski Chalet",
      "phoneFormatted": "(330) 652-7913",
      "phone": "3306527913",
      "address": "1041 Youngstown-Warren Rd.",
      "city": "Niles",
      "country": "United States",
      "postalCode": "44446",
      "state": "OH",
      "url": "https://theskichalet.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -112.001532397114,
        33.6791838252122
      ]
    },
    "properties": {
      "name": "Ski Pro Desert Ridge",
      "phoneFormatted": "(480) 443-5670",
      "phone": "4804435670",
      "address": "21001 N Tatum Blvd",
      "city": "Phoenix",
      "country": "United States",
      "postalCode": "85050",
      "state": "AZ",
      "url": "https://skipro.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.847164363569,
        33.3781345072948
      ]
    },
    "properties": {
      "name": "Ski Pro Mesa",
      "phoneFormatted": "(480) 962-6910",
      "phone": "4809626910",
      "address": "1924 W Rio Salado Pkwy",
      "city": "Mesa",
      "country": "United States",
      "postalCode": "85210",
      "state": "AZ",
      "url": "https://skipro.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -119.812658,
        39.5261788
      ]
    },
    "properties": {
      "name": "Ski Pro Reno",
      "phoneFormatted": "(775) 420-3427",
      "phone": "7754203427",
      "address": "6407 S Virginia St",
      "city": "Reno",
      "country": "United States",
      "postalCode": "89511",
      "state": "NV",
      "url": "https://skipro.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -82.5154471,
        40.75839
      ]
    },
    "properties": {
      "name": "Snow Trails Ski Shop",
      "phoneFormatted": "(419) 756-3105",
      "phone": "4197563105",
      "address": "3100 Possum Run Rd",
      "city": "Mansfield",
      "country": "United States",
      "postalCode": "44904",
      "state": "OH",
      "url": "https://www.snowtrails.com/footer/snow-trails-ski-shop"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.4547891,
        42.9956397
      ]
    },
    "properties": {
      "name": "Snowboard Jones",
      "phoneFormatted": "(603) 627-7433",
      "phone": "6036277433",
      "address": "150 Kaye St",
      "city": "Manchester",
      "country": "United States",
      "postalCode": "03103",
      "state": "NH",
      "url": "https://www.snowboardjones.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.8521549021176,
        44.1123809635294
      ]
    },
    "properties": {
      "name": "Splinters Boardshop",
      "phoneFormatted": "(802) 496-7441",
      "phone": "8024967441",
      "address": "18 Sugarbush Access Rd",
      "city": "Warren",
      "country": "United States",
      "postalCode": "05674",
      "state": "VT",
      "url": "https://splintersboardshop.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.879292,
        37.251535
      ]
    },
    "properties": {
      "name": "Sports Basement Almaden - U113",
      "phoneFormatted": "(408) 598-4256",
      "phone": "4085984256",
      "address": "5353 Almaden Expy",
      "city": "San Jose",
      "country": "United States",
      "postalCode": "95118",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.2690426,
        37.8595046
      ]
    },
    "properties": {
      "name": "Sports Basement Berkeley - U107",
      "phoneFormatted": "(510) 984-3907",
      "phone": "5109843907",
      "address": "2727 Milvia St",
      "city": "Berkeley",
      "country": "United States",
      "postalCode": "94703",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.4111318,
        37.7670976
      ]
    },
    "properties": {
      "name": "Sports Basement Bryant St U103",
      "phoneFormatted": "(415) 575-3001",
      "phone": "4155753001",
      "address": "1590 Bryant Street",
      "city": "San Francisco",
      "country": "United States",
      "postalCode": "94103",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.9330289,
        37.2888019
      ]
    },
    "properties": {
      "name": "Sports Basement Campbell U106",
      "phoneFormatted": "(408) 899-5783",
      "phone": "4088995783",
      "address": "1875 S Bascom Ave Suite 240",
      "city": "Campbell",
      "country": "United States",
      "postalCode": "95008",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.125217322033,
        33.7943067457627
      ]
    },
    "properties": {
      "name": "Sports Basement Long Beach - U202",
      "phoneFormatted": "(714) 587-2161",
      "phone": "7145872161",
      "address": "2100 N Bellflower Blvd",
      "city": "Long Beach",
      "country": "United States",
      "postalCode": "90815",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.55498,
        38.093484
      ]
    },
    "properties": {
      "name": "Sports Basement Novato U110",
      "phoneFormatted": "(415) 493-2623",
      "phone": "4154932623",
      "address": "100 Vintage Way",
      "city": "Novato",
      "country": "United States",
      "postalCode": "94945",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -117.9406493,
        33.6993369
      ]
    },
    "properties": {
      "name": "Sports Basement Orange County - U201",
      "phoneFormatted": "(714) 587-2112",
      "phone": "7145872112",
      "address": "10800 Kalama River Ave",
      "city": "Fountain Valley",
      "country": "United States",
      "postalCode": "92708",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.458902,
        37.802898
      ]
    },
    "properties": {
      "name": "Sports Basement Presidio U102",
      "phoneFormatted": "(415) 934-2900",
      "phone": "4159342900",
      "address": "610 Old Mason Street",
      "city": "San Francisco",
      "country": "United States",
      "postalCode": "94129",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.2258382,
        37.4931871
      ]
    },
    "properties": {
      "name": "Sports Basement Redwood City U111",
      "phoneFormatted": "(650) 421-7440",
      "phone": "6504217440",
      "address": "202 Walnut Street",
      "city": "Redwood City",
      "country": "United States",
      "postalCode": "94063",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.953018,
        37.7620092
      ]
    },
    "properties": {
      "name": "Sports Basement San Ramon U109",
      "phoneFormatted": "(925) 498-6130",
      "phone": "9254986130",
      "address": "1041 Market Place",
      "city": "San Ramon",
      "country": "United States",
      "postalCode": "94583",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.7091124,
        38.4180092
      ]
    },
    "properties": {
      "name": "Sports Basement Santa Rosa U108",
      "phoneFormatted": "(707) 921-3147",
      "phone": "7079213147",
      "address": "1970 Santa Rosa Avenue",
      "city": "Santa Rosa",
      "country": "United States",
      "postalCode": "95407",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.373224,
        33.9009051
      ]
    },
    "properties": {
      "name": "Sports Basement South Bay U203",
      "phoneFormatted": "(424) 236-3966",
      "phone": "4242363966",
      "address": "14351 Hindry Avenue",
      "city": "Hawthorne",
      "country": "United States",
      "postalCode": "90250",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.476682,
        37.7278014
      ]
    },
    "properties": {
      "name": "Sports Basement Stonestown U112",
      "phoneFormatted": "(415) 934-2922",
      "phone": "4159342922",
      "address": "3251 20th Avenue Suite 390",
      "city": "San Francisco",
      "country": "United States",
      "postalCode": "94132",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.996864,
        37.383057
      ]
    },
    "properties": {
      "name": "Sports Basement Sunnyvale U104",
      "phoneFormatted": "(408) 598-4240",
      "phone": "4085984240",
      "address": "1177 Kern Ave",
      "city": "Sunnyvale",
      "country": "United States",
      "postalCode": "94085",
      "state": "CA",
      "url": "https://www.sportsbasement.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -123.0724287,
        49.3279933
      ]
    },
    "properties": {
      "name": "The Boardroom - North Vancouver",
      "phoneFormatted": "",
      "phone": "",
      "address": "1465 Charlotte Road",
      "city": "North Vancouver",
      "country": "Canada",
      "postalCode": "V7M 2K4",
      "state": "British Columbia",
      "url": "https://boardroomshop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -78.6727799,
        42.2751873
      ]
    },
    "properties": {
      "name": "The Boardroom Snowboard Shop",
      "phoneFormatted": "(716) 699-5620",
      "phone": "7166995620",
      "address": "6113 Route 219 S",
      "city": "Ellicottville",
      "country": "United States",
      "postalCode": "14731",
      "state": "NY",
      "url": "https://www.boardsandpowder.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -85.5740258549935,
        42.205853140856
      ]
    },
    "properties": {
      "name": "The Edge",
      "phoneFormatted": "(269) 327-1000",
      "phone": "2693271000",
      "address": "9009 Portage Rd",
      "city": "Portage",
      "country": "United States",
      "postalCode": "49002",
      "state": "MI",
      "url": "https://www.edgeski.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.3120337,
        41.0448641
      ]
    },
    "properties": {
      "name": "The Loft",
      "phoneFormatted": "(570) 629-2627",
      "phone": "5706292627",
      "address": "1824 Sullivan Trail",
      "city": "Tannersville",
      "country": "United States",
      "postalCode": "18372",
      "state": "PA",
      "url": "https://loftsports.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.4904323,
        39.919698
      ]
    },
    "properties": {
      "name": "The Ski Bum",
      "phoneFormatted": "(610) 459-4778",
      "phone": "6104594778",
      "address": "200 Town Centre Drive #9",
      "city": "Glen Mills",
      "country": "United States",
      "postalCode": "19342",
      "state": "PA",
      "url": "https://www.theskibum.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.7436049503474,
        39.6946824507264
      ]
    },
    "properties": {
      "name": "The Ski Bum",
      "phoneFormatted": "(302) 454-9829",
      "phone": "3024549829",
      "address": "218 East Main St",
      "city": "Newark",
      "country": "United States",
      "postalCode": "19711",
      "state": "DE",
      "url": "https://www.theskibum.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.6075851,
        42.2071184
      ]
    },
    "properties": {
      "name": "Theory Skateshop",
      "phoneFormatted": "(413) 534-7669",
      "phone": "4135347669",
      "address": "50 Holyoke St",
      "city": "Holyoke",
      "country": "United States",
      "postalCode": "01040",
      "state": "MA",
      "url": "https://theoryskate.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.7547596,
        45.3041033
      ]
    },
    "properties": {
      "name": "Timberline Lodge",
      "phoneFormatted": "(503) 272-3311",
      "phone": "5032723311",
      "address": "27500 E Timberline Road",
      "city": "Government Camp",
      "country": "United States",
      "postalCode": "97028",
      "state": "OR",
      "url": "https://www.timberlinelodge.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -84.1344979028626,
        39.6912096106782
      ]
    },
    "properties": {
      "name": "Valleywood Ski & Snowboard Shop",
      "phoneFormatted": "(937) 298-7125",
      "phone": "9372987125",
      "address": "3850 Wilmington Pike",
      "city": "Kettering",
      "country": "United States",
      "postalCode": "45429",
      "state": "OH",
      "url": "https://www.valleywoodski.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        20.2113334,
        63.8316307
      ]
    },
    "properties": {
      "name": "VESTBERGS I UMEA AB",
      "phoneFormatted": "",
      "phone": "",
      "address": "Godemansvägen 21",
      "city": "Umeå",
      "country": "Sweden",
      "postalCode": "903 55",
      "state": "Västerbotten",
      "url": "https://vo-shop.se/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -88.1368462040816,
        42.1614053061224
      ]
    },
    "properties": {
      "name": "Viking Ski Shop - Barrington",
      "phoneFormatted": "(847) 381-1188",
      "phone": "8473811188",
      "address": "131 W Northwest Hwy",
      "city": "Barrington",
      "country": "United States",
      "postalCode": "60010",
      "state": "IL",
      "url": "https://vikingskishop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.7130586,
        41.924909
      ]
    },
    "properties": {
      "name": "Viking Ski Shop - Chicago",
      "phoneFormatted": "(773) 276-1222",
      "phone": "7732761222",
      "address": "3422 W Fullerton Ave",
      "city": "Chicago",
      "country": "United States",
      "postalCode": "60647",
      "state": "IL",
      "url": "https://vikingskishop.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.020851,
        40.36494
      ]
    },
    "properties": {
      "name": "Willi South hill",
      "phoneFormatted": "(412) 881-5660",
      "phone": "4128815660",
      "address": "3738 Library Rd",
      "city": "Pittsburgh",
      "country": "United States",
      "postalCode": "15234",
      "state": "PA",
      "url": "https://www.willisskiandboard.com"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -111.034876758341,
        45.6839544471502
      ]
    },
    "properties": {
      "name": "World Boards",
      "phoneFormatted": "(406) 587-1707",
      "phone": "4065871707",
      "address": "601 W Main St",
      "city": "Bozeman",
      "country": "United States",
      "postalCode": "59715",
      "state": "MT",
      "url": "https://www.worldboards.com/"
    }
  },
  {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [
        -93.2893004526547,
        44.7300271064924
      ]
    },
    "properties": {
      "name": "Zombie Boardshop",
      "phoneFormatted": "(952) 892-0047",
      "phone": "9528920047",
      "address": "15100 Buck Hill Rd",
      "city": "Burnsville",
      "country": "United States",
      "postalCode": "55306",
      "state": "MN",
      "url": "https://www.zombieboardshop.com/"
    }
  }
    ]
};